import React, { FC, ReactNode } from 'react';

type WithClassNameProps = {
  className?: string;
  children: (className?: string) => ReactNode;
};

export const WithClassName: FC<WithClassNameProps> = ({ className, children }) => <>{children(className)}</>;
